// Persistenz-Abstraktion. Phase 1 nutzt localStorage; Phase 2 ersetzt die Implementierung
// durch einen platform-api-Adapter (Cloudflare D1/Worker), ohne Lernlogik oder UI anzufassen.
export interface StateStorage {
  load(): string | null;
  save(value: string): void;
  clear(): void;
}

// In-memory backend — für Tests und für SSR/Non-Browser-Kontexte.
export function createMemoryStorage(): StateStorage {
  let value: string | null = null;
  return {
    load: () => value,
    save: (next: string) => {
      value = next;
    },
    clear: () => {
      value = null;
    },
  };
}

// Browser-Persistenz über localStorage; fällt auf no-op zurück, wenn nicht verfügbar.
export function createLocalStorage(key: string): StateStorage {
  const available = typeof localStorage !== "undefined";
  return {
    load: () => (available ? localStorage.getItem(key) : null),
    save: (value: string) => {
      if (available) localStorage.setItem(key, value);
    },
    clear: () => {
      if (available) localStorage.removeItem(key);
    },
  };
}
